import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import Logo from '../../assets/images/logo-fairytale-new.png';
import qrIcon from '../../assets/images/qr-icon.svg';
import searchIcon from '../../assets/images/search-icon.svg';
import iconBeranda from '../../assets/images/icon-beranda.svg';
import iconTamu from '../../assets/images/icon-tamu.svg';
import iconLayarSapa from '../../assets/images/icon-layar-sapa.svg';
import iconArrow from '../../assets/images/icon-arrow.svg';
import './AppLayout.css';

/**
 * Shell shared by Dashboard and Riwayat Check-in: left nav, top search bar,
 * and the floating QR button that drops back into the scanner.
 */
function AppLayout({ children, searchValue, onSearchChange, onSearchSubmit }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const clientName = localStorage.getItem('selectedPostTitle') || '';
  const usherName = localStorage.getItem('name') || '';
  const role = localStorage.getItem('role') || 'usher';
  const isUsher = role === 'usher';

  // Straight to the camera - skip the Layar Sapa screen.
  const goToScanner = () => navigate('/', { state: { skipWelcome: true } });

  // Back to the Layar Sapa (welcome) screen.
  const goToLayarSapa = () => navigate('/', { state: { skipWelcome: false } });

  const handleLogout = () => {
    Swal.fire({
      title: 'Logout Sekarang?',
      showCancelButton: true,
      confirmButtonText: 'Ya',
      cancelButtonText: 'Tidak',
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        navigate('/login');
      }
      setMenuOpen(false);
    });
  };

  const navItems = [
    { key: 'dashboard', label: 'Beranda', path: '/dashboard', icon: iconBeranda },
    { key: 'tamu', label: 'Tamu', path: '/tamu', icon: iconTamu },
  ];

  return (
    <div className="app-layout">
      <aside className={`app-sidebar ${menuOpen ? 'is-open' : ''}`}>
        <img src={Logo} alt="Serenity" className="app-sidebar__logo" />

        <nav className="app-nav">
          {navItems.map(({ key, label, path, icon }) => (
            <button
              key={key}
              type="button"
              className={`app-nav__item ${pathname === path ? 'is-active' : ''}`}
              onClick={() => {
                navigate(path);
                setMenuOpen(false);
              }}
            >
              <img className="app-nav__icon" src={icon} alt="" />
              <span>{label}</span>
            </button>
          ))}

          {isUsher && (
            <button
              type="button"
              className="app-nav__item app-nav__item--plain"
              onClick={() => {
                goToLayarSapa();
                setMenuOpen(false);
              }}
            >
              <img className="app-nav__icon" src={iconLayarSapa} alt="" />
              <span>Layar Sapa</span>
              <img className="app-nav__ext" src={iconArrow} alt="" />
            </button>
          )}
        </nav>

        <div className="app-sidebar__footer">
          <div className="app-sidebar__who">
            {clientName && <p className="app-sidebar__client">{clientName}</p>}
            {usherName && (
              <p className="app-sidebar__usher">
                {isUsher ? 'Usher' : 'Viewer'}: {usherName}
              </p>
            )}
          </div>
          <button type="button" className="app-sidebar__logout" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </aside>

      {menuOpen && <div className="app-scrim" onClick={() => setMenuOpen(false)} />}

      <div className="app-main">
        <header className="app-topbar">
          <form
            className="app-search"
            onSubmit={(e) => {
              e.preventDefault();
              if (onSearchSubmit) onSearchSubmit();
            }}
          >
            <img src={searchIcon} alt="" className="app-search__icon" />
            <input
              type="text"
              placeholder="Cari nama tamu . . ."
              value={searchValue ?? ''}
              onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
              disabled={!onSearchChange}
            />
          </form>

          <button
            type="button"
            className="app-burger"
            aria-label="Menu"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span />
            <span />
            <span />
          </button>
        </header>

        <div className="app-content">{children}</div>

        {isUsher && (
          <button
            type="button"
            className="app-fab"
            aria-label="Kembali ke Scanner"
            title="Kembali ke Scanner"
            onClick={goToScanner}
          >
            <img src={qrIcon} alt="" />
          </button>
        )}
      </div>
    </div>
  );
}

export default AppLayout;
